module.exports = __webpack_public_path__ + "media/images/icon__unlocked@3x-40c29add91e654af13185386d1feb942.png";